import { render, staticRenderFns } from "./LectureReady.vue?vue&type=template&id=6b887522&scoped=true&"
import script from "./LectureReady.vue?vue&type=script&lang=js&"
export * from "./LectureReady.vue?vue&type=script&lang=js&"
import style0 from "./LectureReady.vue?vue&type=style&index=0&id=6b887522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b887522",
  null
  
)

export default component.exports